import { useEvent } from '@utsubo/events'
import { useRef } from 'react'

let isLogHandlerSetup = false
let ignoreThisError = false
function formatMessage(args, maxLen = 400) {
  if (!args.length) {
    return `Couldn't get the error message`;
  }

  let msg = '';
  for (let i = 0; i < args.length; i++) {
    if (typeof args[i] === 'string') {
      msg += args[i] + ' ';
    } else if (args[i] instanceof Error) {
      msg += args[i].message + ' ';
    } else if (typeof args[i] === 'object') {
      msg += JSON.stringify(args[i]) + ' ';
    } else {
      msg += args[i] + ' ';
    }
  }

  if (msg.length > maxLen) {
    let startMsg = msg.slice(0, maxLen / 2);
    let endMsg = msg.slice(-maxLen / 2);
    msg = `${startMsg}...${endMsg}`;
  }
  
  return msg;
}


const addToSession = (
  logsInCurrentSession,
  type,
  message = '',
  source = '',
  lineno = '',
  colno = '',
  error
) => {
  const log = {
    type: type,
    message: message,
    source: source,
    host: typeof window !== 'undefined' ? window.location.host : '',
    line: lineno,
    column: colno,
    error: error ? error.toString() : '',
  }

  const stringifiedLog = JSON.stringify(log)
  logsInCurrentSession.current[stringifiedLog] = {
    ...(logsInCurrentSession.current[stringifiedLog] || log),
    count: (logsInCurrentSession.current[stringifiedLog]?.count || 0) + 1,
    timestamp:
      logsInCurrentSession.current[stringifiedLog]?.timestamp ||
      new Date().getTime(),
  }
}

async function saveAllLogsToFirestore(
  logsInCurrentSession,
  workspace,
  microverse
) {
  let groupedLogs = Object.values(logsInCurrentSession.current)

  try {
    await fetch('/api/save-logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ logs: groupedLogs, workspace, microverse }),
    })
    // After successfully sending logs, clear the logsInCurrentSession.
    logsInCurrentSession.current = {}
  } catch (err) {
    ignoreThisError = true
    console.error('Failed to save logs:', err)
    ignoreThisError = false
  }
}

export const useLogsReport = (workspace, microverse) => {
  const logsInCurrentSession = useRef({})

  // if (process.env.NODE_ENV === 'development') return

  if (typeof window !== 'undefined' && !isLogHandlerSetup) {
    isLogHandlerSetup = true
    let originalConsoleWarn = console.warn
    console.warn = function (...args) {
      let message = formatMessage(args)
      originalConsoleWarn.apply(console, args)
      addToSession(logsInCurrentSession, 'warning', message)
    }

    let originalConsoleError = console.error
    console.error = function (...args) {
      let message = formatMessage(args);
      originalConsoleError.apply(console, args);
      if (!ignoreThisError) {
        addToSession(logsInCurrentSession, 'error', message);
      }
    }

    window.onerror = function (message, source, lineno, colno, error) {
      addToSession(
        logsInCurrentSession,
        'exception',
        message,
        source,
        lineno,
        colno,
        error
      )
      saveAllLogsToFirestore(logsInCurrentSession, workspace, microverse)
    }

    window.onunhandledrejection = function (event) {
      console.log('event.reason', event.reason)
      addToSession(
        logsInCurrentSession,
        'unhandledRejection',
        event.reason.message || event.reason,
        '',
        '',
        '',
        event.reason
      )
      saveAllLogsToFirestore(logsInCurrentSession, workspace, microverse)
    }
  }

  useEvent('postAnimFinishLoad', () => {
    setTimeout(() => {
      saveAllLogsToFirestore(logsInCurrentSession, workspace, microverse)
    }, 3000)
  })
}
